export default "__VITE_ASSET__b5958a4c__"